import { memo } from 'react'
import { Link, Stack, Text } from 'ui/baseComponents'
import ReportSection from './ReportSection'
import { VIDEO_LINKS } from '../consts'
import { useReportTranslation } from 'utilities/i18n'

const ReportFooter = ({ showLLMDisclaimer, isClinicianReport }) => {
  const { t } = useReportTranslation()

  const STYLES = {
    contactInfo: {
      '& span:not(:first-of-type)::before': {
        content: '"|"',
        marginLeft: '1rem',
        marginRight: '1rem',
      },
    },
  }

  return (
    <ReportSection>
      <Stack spacing={4}>
        {!isClinicianReport && (
          <Text variant="body16" component="p">
            {t('report.footer.patientIntroBefore')}
            <Link href={VIDEO_LINKS.bestPractices} external underline light>
              {t('report.footer.watchOurVideo')}
            </Link>
            {t('report.footer.patientIntroAfter')}
          </Text>
        )}

        {!isClinicianReport && (
          <>
            {showLLMDisclaimer && (
              <Text variant="body14" component="p">
                {t('report.footer.llmDisclaimer')}
              </Text>
            )}
            <div>
              <Text variant="body14" component="p">
                {t('report.footer.confidential')}
              </Text>
              <Text variant="body14B" component="p">
                {t('report.footer.emergency')}
              </Text>
            </div>
          </>
        )}

        <Stack
          direction="row"
          justifyContent="center"
          spacing={0}
          sx={STYLES.contactInfo}
        >
          <Text variant="body16">{t('report.footer.support')}</Text>
          <Text variant="body16">
            {t('report.footer.emailLabel')}{' '}
            <Link href="mailto:support@runelabs.io" light external underline>
              support@runelabs.io
            </Link>
          </Text>
          <Text variant="body16">
            <Link href="https://www.strive.group" external light underline>
              www.strive.group
            </Link>
          </Text>
        </Stack>
      </Stack>
    </ReportSection>
  )
}

export default memo(ReportFooter)
